import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DiffField } from '../../../../../shared/models/internal/diffs/diff-field';
import { PartType } from '../../../../../shared/enums/part-type';
import { DiffFieldViewer } from '../diff-field-viewer/diff-field-viewer';

@Component({
  selector: 'app-diff-viewer',
  imports: [DiffFieldViewer],
  templateUrl: './diff-viewer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './diff-viewer.scss',
})
export class DiffViewer {
  @Input() public diffFields: DiffField[] = [];

  protected readonly partType = PartType;
}
